// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import testLibReducer from './testLib/testLibSlice'; // adjust path if needed
import clientsReducer from './clientsSlice'; // adjust path if needed
import usersReducer from "./usersSlice"
import searchReducer from "./searchSlice"
import slateLibReducer from './slateLibSlice';

export const store = configureStore({
  reducer: {
    testLib: testLibReducer,
    slateLib: slateLibReducer,
    clients: clientsReducer,
    users: usersReducer,
    search: searchReducer
  }
});